import {Swiper, SwiperSlide} from "swiper/react"
import {PaginationOptions} from "swiper/types"
import {Pagination} from "swiper"
import {FC, ReactNode} from "react"

import cn from "classnames"

interface Props {
  className?: string
  children: ReactNode
}

const pagination: PaginationOptions = {
  clickable: true,
  renderBullet: (_, className) => {
    return `<span class="${className}"></span>`
  }
}

// Буллеты работают нормально на маленьких экранах меньше 380 только с отступом 10
export const Carousel: FC<Props> = ({children, className}) => (
  <Swiper
    spaceBetween={10}
    slidesOffsetBefore={20}
    slidesOffsetAfter={20}
    slidesPerView="auto"
    modules={[Pagination]}
    pagination={pagination}
    watchOverflow
    className={cn("pb-16", className)}
  >
    {children}
  </Swiper>
)

export const Slide = SwiperSlide
